import { defineComponent as _defineComponent } from 'vue'
import TermsHeader from "@/components/landing/TermsHeader.vue";
  import LandingFooter from "@/components/landing/LandingFooter.vue";
  import { ref, onMounted } from "vue";
  import router from "@/router";
  import store from "@/store";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Rei',
  setup(__props, { expose: __expose }) {
  __expose();

  const params = new URLSearchParams(window.location.hash.slice(1));
  const isTokenReady = ref(false);
  const accessToken = params.get("access_token");

  const onBack = () => {
    const eoiId = sessionStorage.getItem("eoiId");

    sessionStorage.removeItem("eoiId");
    router.push(`/eoi/${eoiId}`);
  };

  onMounted(() => {
    store.commit("rei/setUserData", {
      accessToken,
    });

    if (store.state.rei.userData.accessToken) {
      isTokenReady.value = true;
    }
  });

const __returned__ = { params, isTokenReady, accessToken, onBack, TermsHeader, LandingFooter, ref, onMounted, get router() { return router }, get store() { return store } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})